import React, {useState, useCallback} from "react";
import {KEY_CODES} from "../../../consts";
import {useEventListener} from "../../../../infrastructure/hooks/useEventListener";

export const TripleCarouselComposer = (TripleCarousel) => ((props) => {
  const childrenCount: Number = React.Children.count(props.children);

  if (childrenCount === 1) {
    return props.children;
  }

  const angle = 360 / childrenCount;
  const itemWidth = props.activeItemWidth;
  let radius = Math.round((itemWidth / 2) / Math.tan(Math.PI / childrenCount)) + props.minDistanceBetweenItems;

  // Calculate radius based on item width and desired minimum distance
  if(props.itemsShouldOverlap) {
    radius = Math.round((itemWidth / 3) / Math.tan(Math.PI / childrenCount));
  }

  const isIndexInRange = (props.initialIndex > -1 && props.initialIndex < childrenCount)

  const [currentIndex, setCurrentIndex] = useState(isIndexInRange ? props.initialIndex : 0);
  const [currentDegrees, setCurrentDegrees] = useState(-currentIndex * angle);

  const previousItem = currentIndex === 0 ? childrenCount - 1 : currentIndex - 1;
  const nextItem = currentIndex === childrenCount - 1 ? 0 : currentIndex + 1;

  const onKeyboardClick = useCallback((event) => {
    const onPressBackward: Boolean = props.isRtl ? event.keyCode === KEY_CODES.right : event.keyCode === KEY_CODES.left;
    const onPressForward: Boolean = props.isRtl ? event.keyCode === KEY_CODES.left : event.keyCode === KEY_CODES.right;

    onPressBackward && handleSlidePrevious();
    onPressForward && handleSlideNext();
  });

  useEventListener('keydown', onKeyboardClick);

  const handleSlidePrevious = () => {
    setCurrentDegrees(currentDegrees + angle);
    setCurrentIndex(previousItem)
    props.onChange && props.onChange(previousItem);
  }

  const handleSlideNext = () => {
    setCurrentDegrees(currentDegrees - angle);
    setCurrentIndex(nextItem)
    props.onChange && props.onChange(nextItem);
  }

  const isActiveItem = (index) => {
    return currentIndex === index
  }

  const isSecondaryItem = (index) => {
    return previousItem === index || nextItem === index
  }

  const onItemClick = (index) => {
    if (index === previousItem) {
      return handleSlidePrevious()
    } else if (index === nextItem) {
      return handleSlideNext()
    }
  }

  const newProps = {
    childrenCount: childrenCount,
    currentDegrees: currentDegrees,
    angle: angle,
    radius: radius,
    handleSlidePrevious: () => handleSlidePrevious(),
    handleSlideNext: () => handleSlideNext(),
    isActiveItem: (index) => isActiveItem(index),
    isSecondaryItem: (index) => isSecondaryItem(index),
    onItemClick: (e, index) => onItemClick(e, index),
    ...props
  };


  return (
    <TripleCarousel {...newProps} />
  );
});
